import React from "react";
import "./App.css";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import MomentsSection from "./components/MomentsSection";
import ScholarshipSection from "./components/ScholarshipSection";
import MDMessageSection from "./components/MDMessageSection";
import FooterCTA from "./components/FooterCTA";
import InnovationSection from "./components/InnovationSection";
import CookieBanner from "./components/Cookie";

const App: React.FC = () => {
  return (
    <div className="App">
      <HeroSection />
      <InnovationSection />
      <StatsSection />
      <ScholarshipSection />
      <MomentsSection />
      <MDMessageSection />
      <FooterCTA />
      <CookieBanner />
    </div>
  );
};

export default App;
